import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processTableSetting = (store, item) => {
   store.commit(mutations.ADD_OR_UPDATE_TABLE_SETTING, item)
}

export const fetchTableSettings = (store, params) => {
    return axios.get(`/api/table-settings/`, params)
        .then(res => {
            processTableSetting(store, res.data.data)
            return res
        })
}

export const updateTableSetting = (store, item) => {
    return axios.patch(`/api/table-settings/${item.slug}`, item)
        .then(res => {
            processTableSetting(store, res.data.data)
            return res
        })
}

export const removeTableSetting = (store, item) => {
    return axios.delete(`/api/table-settings/${item.slug}`)
        .then(res => {
            store.commit(mutations.REMOVE_TABLE_SETTING, item)
            return res
        })
}
